import React, { Component } from 'react';
import './App.css';
import styled from 'styled-components';

import Filter from './components/Filter/Filter';


class App extends Component {
 

  render() {
    return (
      <div className="App"> 
        <Filter></Filter>
      </div>
    );
  }
}


export default App;
